import { getDepositEligibility } from '@services/queries'
import { useQuery } from 'react-query'

/**
 * Hook to fetch deposit eligibility data for a player.
 * Disables the query when currencyCode is falsy.
 *
 * @param {string} playerId - The player's ID
 * @param {string} currencyCode - The player's currency code
 * @returns {{ data: object|undefined, isLoading: boolean, isError: boolean }}
 */
export function useDepositEligibility(playerId, currencyCode, options = {}) {
  const { data, isLoading, isError } = useQuery(
    ['deposit_eligibility', playerId, currencyCode],
    () => getDepositEligibility(playerId, currencyCode),
    {
      enabled: !!currencyCode && options.enabled !== false,
      ...options,
    },
  )
  return { data, isLoading, isError }
}
